import { Grid, Link, Typography, useMediaQuery } from '@mui/material'
import { LogoInnovatrics, Translate } from '@innovatrics/checkin-components'
import { useParams } from 'react-router-dom'
import { useGetSharedLinkQuery } from '../generated/graphql'

interface FooterProps {
  white?: boolean
}

export const Footer = ({ white }: FooterProps) => {
  const { hash } = useParams()
  const [{ data }] = useGetSharedLinkQuery({
    variables: { hash },
  })
  const matches = useMediaQuery('(min-width:750px)')
  return (
    <div
      style={{
        bottom: 0,
        width: '100%',
        background: white ? '#FFFFFF' : '#F2F3F4',
      }}
    >
      <Grid
        container
        justifyContent={'space-between'}
        justifyItems={'center'}
        paddingY={'30px'}
        marginX={'auto'}
        paddingX={'16px'}
        maxWidth={'1168px'}
        flexDirection={matches ? 'row' : 'column'}
        alignItems={'center'}
        alignContent={'center'}
      >
        <Grid item>
          <Typography fontWeight={400} fontSize={'14px'} align={'center'}>
            <Translate
              entityName={'footer.help.hotel'}
              defaultMessage={
                'Need help or Interested in integrating Digital Onboarding Toolkit?'
              }
            />
            {'  '}
            <Link
              href={`mailto:${data?.sharedLinks?.[0]?.organization?.email}`}
              target="_blank"
            >
              <Translate
                entityName={'footer.help.hotel.link'}
                defaultMessage={'Email to Hotelier'}
              />
            </Link>
          </Typography>
        </Grid>
        <Grid item sx={{ marginTop: matches ? '0' : '15px' }}>
          <a href="https://www.innovatrics.com/" target="_blank">
            <LogoInnovatrics />
          </a>
        </Grid>
      </Grid>
    </div>
  )
}
